Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toLinearSpace = exports.toGammaSpace = exports.rgbaColor = exports.rgbaArrayToRGBAColor = exports.red = exports.processColorsInProps = exports.processColor = exports.opacity = exports.isColor = exports.hsvToColor = exports.green = exports.convertToRGBA = exports.blue = exports.RGBtoHSV = exports.ColorProperties = void 0;
var _core = require("./core");
var _PlatformChecker = require("./PlatformChecker");
var NUMBER = "[-+]?(?:\\d+(?:\\.\\d*)?|\\.\\d+)";
var PERCENTAGE = NUMBER + "%";
var _worklet_17112204286815_init_data = {
    code: "function call(...args){return'\\\\(\\\\s*('+args.join(')\\\\s*,\\\\s*(')+')\\\\s*\\\\)';}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["call","args","join"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA4BA,SAAAA,IAASA,CAAK,GAAAC,IAAG,CAAgB,CAE/B,MAAO,UAAU,CAAGA,IAAI,CAACC,IAAI,CAAC,aAAa,CAAC,CAAG,UAAU,CAC3D"}',
    version: "3.5.4"
};
var call = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var call = function call() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return "\\(\\s*(" + args.join(")\\s*,\\s*(") + ")\\s*\\)";
    };
    call.__closure = {};
    call.__initData = _worklet_17112204286815_init_data;
    call.__workletHash = 17112204286815;
    call.__stackDetails = _e;
    return call;
}();
var MATCHERS = {
    rgb: new RegExp("rgb" + call(NUMBER, NUMBER, NUMBER)),
    rgba: new RegExp("rgba" + call(NUMBER, NUMBER, NUMBER, NUMBER)),
    hsl: new RegExp("hsl" + call(NUMBER, PERCENTAGE, PERCENTAGE)),
    hsla: new RegExp("hsla" + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
    hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#([0-9a-fA-F]{6})$/,
    hex8: /^#([0-9a-fA-F]{8})$/
};
var _worklet_3618366985414_init_data = {
    code: "function hue2rgb(p,q,t){if(t<0){t+=1;}if(t>1){t-=1;}if(t<1/6){return p+(q-p)*6*t;}if(t<1/2){return q;}if(t<2/3){return p+(q-p)*(2/3-t)*6;}return p;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["hue2rgb","p","q","t"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA4CA,SAAAA,OAASA,CAAQC,CAAC,CAAQC,CAAG,CAAQC,CAAG,CAAS,CAE/C,GAAIA,CAAC,CAAG,CAAC,CAAE,CACTA,CAAC,EAAI,CAAC,CACR,CACA,GAAIA,CAAC,CAAG,CAAC,CAAE,CACTA,CAAC,EAAI,CAAC,CACR,CACA,GAAIA,CAAC,CAAG,CAAC,CAAG,CAAC,CAAE,CACb,MAAO,CAAAF,CAAC,CAAG,CAACC,CAAC,CAAGD,CAAC,EAAI,CAAC,CAAGE,CAAC,CAC5B,CACA,GAAIA,CAAC,CAAG,CAAC,CAAG,CAAC,CAAE,CACb,MAAO,CAAAD,CAAC,CACV,CACA,GAAIC,CAAC,CAAG,CAAC,CAAG,CAAC,CAAE,CACb,MAAO,CAAAF,CAAC,CAAG,CAACC,CAAC,CAAGD,CAAC,GAAK,CAAC,CAAG,CAAC,CAAGE,CAAC,CAAC,CAAG,CAAC,CACtC,CACA,MAAO,CAAAF,CAAC,CACV"}',
    version: "3.5.4"
};
var hue2rgb = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var hue2rgb = function hue2rgb(p, q, t) {
        if (t < 0) {
            t += 1;
        }
        if (t > 1) {
            t -= 1;
        }
        if (t < 1 / 6) {
            return p + (q - p) * 6 * t;
        }
        if (t < 1 / 2) {
            return q;
        }
        if (t < 2 / 3) {
            return p + (q - p) * (2 / 3 - t) * 6;
        }
        return p;
    };
    hue2rgb.__closure = {};
    hue2rgb.__initData = _worklet_3618366985414_init_data;
    hue2rgb.__workletHash = 3618366985414;
    hue2rgb.__stackDetails = _e;
    return hue2rgb;
}();
var _worklet_3939876868199_init_data = {
    code: "function hslToRgb(h,s,l){const{hue2rgb}=this.__closure;const q=l<0.5?l*(1+s):l+s-l*s;const p=2*l-q;const r=hue2rgb(p,q,h+1/3);const g=hue2rgb(p,q,h);const b=hue2rgb(p,q,h-1/3);return Math.round(r*255)<<24|Math.round(g*255)<<16|Math.round(b*255)<<8;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["hslToRgb","h","s","l","hue2rgb","__closure","q","p","r","g","b","Math","round"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAgEA,SAAAA,QAASA,CAASC,CAAC,CAAQC,CAAG,CAAQC,CAAG,CAAS,OAAAC,OAAA,OAAAC,SAAA,CAEhD,KAAM,CAAAC,CAAC,CAAGH,CAAC,CAAG,GAAG,CAAGA,CAAC,EAAI,CAAC,CAAGD,CAAC,CAAC,CAAGC,CAAC,CAAGD,CAAC,CAAGC,CAAC,CAAGD,CAAC,CAC/C,KAAM,CAAAK,CAAC,CAAG,CAAC,CAAGJ,CAAC,CAAGG,CAAC,CACnB,KAAM,CAAAE,CAAC,CAAGJ,OAAO,CAACG,CAAC,CAAED,CAAC,CAAEL,CAAC,CAAG,CAAC,CAAG,CAAC,CAAC,CAClC,KAAM,CAAAQ,CAAC,CAAGL,OAAO,CAACG,CAAC,CAAED,CAAC,CAAEL,CAAC,CAAC,CAC1B,KAAM,CAAAS,CAAC,CAAGN,OAAO,CAACG,CAAC,CAAED,CAAC,CAAEL,CAAC,CAAG,CAAC,CAAG,CAAC,CAAC,CAElC,MACG,CAAAU,IAAI,CAACC,KAAK,CAACJ,CAAC,CAAG,GAAG,CAAC,EAAI,EAAE,CACzBG,IAAI,CAACC,KAAK,CAACH,CAAC,CAAG,GAAG,CAAC,EAAI,EAAG,CAC1BE,IAAI,CAACC,KAAK,CAACF,CAAC,CAAG,GAAG,CAAC,EAAI,CAAE,CAE9B"}',
    version: "3.5.4"
};
var hslToRgb = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var hslToRgb = function hslToRgb(h, s, l) {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        var r = hue2rgb(p, q, h + 1 / 3);
        var g = hue2rgb(p, q, h);
        var b = hue2rgb(p, q, h - 1 / 3);
        return Math.round(r * 255) << 24 | Math.round(g * 255) << 16 | Math.round(b * 255) << 8;
    };
    hslToRgb.__closure = {
        hue2rgb: hue2rgb
    };
    hslToRgb.__initData = _worklet_3939876868199_init_data;
    hslToRgb.__workletHash = 3939876868199;
    hslToRgb.__stackDetails = _e;
    return hslToRgb;
}();
var _worklet_7024550667346_init_data = {
    code: "function parse255(str){const int=Number.parseInt(str,10);if(int<0){return 0;}if(int>255){return 255;}return int;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["parse255","str","int","Number","parseInt"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA+EA,SAAAA,QAASA,CAASC,GAAA,CAAY,CAE5B,KAAM,CAAAC,GAAG,CAAGC,MAAM,CAACC,QAAQ,CAACH,GAAG,CAAE,EAAE,CAAC,CACpC,GAAIC,GAAG,CAAG,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,GAAIA,GAAG,CAAG,GAAG,CAAE,CACb,MAAO,IAAG,CACZ,CACA,MAAO,CAAAA,GAAG,CACZ"}',
    version: "3.5.4"
};
var parse255 = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var parse255 = function parse255(str) {
        var int = Number.parseInt(str, 10);
        if (int < 0) {
            return 0;
        }
        if (int > 255) {
            return 255;
        }
        return int;
    };
    parse255.__closure = {};
    parse255.__initData = _worklet_7024550667346_init_data;
    parse255.__workletHash = 7024550667346;
    parse255.__stackDetails = _e;
    return parse255;
}();
var _worklet_6683812623228_init_data = {
    code: "function parse360(str){const int=Number.parseFloat(str);return(int%360+360)%360/360;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["parse360","str","int","Number","parseFloat"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA2FA,SAAAA,QAASA,CAASC,GAAA,CAAY,CAE5B,KAAM,CAAAC,GAAG,CAAGC,MAAM,CAACC,UAAU,CAACH,GAAG,CAAC,CAClC,MAAQ,CAAEC,GAAG,CAAG,GAAG,CAAI,GAAG,EAAI,GAAG,CAAI,GAAG,CAC1C"}',
    version: "3.5.4"
};
var parse360 = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var parse360 = function parse360(str) {
        var int = Number.parseFloat(str);
        return (int % 360 + 360) % 360 / 360;
    };
    parse360.__closure = {};
    parse360.__initData = _worklet_6683812623228_init_data;
    parse360.__workletHash = 6683812623228;
    parse360.__stackDetails = _e;
    return parse360;
}();
var _worklet_7197247664793_init_data = {
    code: "function parse1(str){const num=Number.parseFloat(str);if(num<0){return 0;}if(num>1){return 255;}return Math.round(num*255);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["parse1","str","num","Number","parseFloat","Math","round"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAiGA,SAAAA,MAASA,CAAOC,GAAA,CAAY,CAE1B,KAAM,CAAAC,GAAG,CAAGC,MAAM,CAACC,UAAU,CAACH,GAAG,CAAC,CAClC,GAAIC,GAAG,CAAG,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,GAAIA,GAAG,CAAG,CAAC,CAAE,CACX,MAAO,IAAG,CACZ,CACA,MAAO,CAAAG,IAAI,CAACC,KAAK,CAACJ,GAAG,CAAG,GAAG,CAAC,CAC9B"}',
    version: "3.5.4"
};
var parse1 = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var parse1 = function parse1(str) {
        var num = Number.parseFloat(str);
        if (num < 0) {
            return 0;
        }
        if (num > 1) {
            return 255;
        }
        return Math.round(num * 255);
    };
    parse1.__closure = {};
    parse1.__initData = _worklet_7197247664793_init_data;
    parse1.__workletHash = 7197247664793;
    parse1.__stackDetails = _e;
    return parse1;
}();
var _worklet_8813932430184_init_data = {
    code: "function parsePercentage(str){const int=Number.parseFloat(str);if(int<0){return 0;}if(int>100){return 1;}return int/100;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["parsePercentage","str","int","Number","parseFloat"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA6GA,SAAAA,eAASA,CAAgBC,GAAA,CAAY,CAGnC,KAAM,CAAAC,GAAG,CAAGC,MAAM,CAACC,UAAU,CAACH,GAAG,CAAC,CAClC,GAAIC,GAAG,CAAG,CAAC,CAAE,CACX,MAAO,EAAC,CACV,CACA,GAAIA,GAAG,CAAG,GAAG,CAAE,CACb,MAAO,EAAC,CACV,CACA,MAAO,CAAAA,GAAG,CAAG,GAAG,CAClB"}',
    version: "3.5.4"
};
var parsePercentage = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var parsePercentage = function parsePercentage(str) {
        var int = Number.parseFloat(str);
        if (int < 0) {
            return 0;
        }
        if (int > 100) {
            return 1;
        }
        return int / 100;
    };
    parsePercentage.__closure = {};
    parsePercentage.__initData = _worklet_8813932430184_init_data;
    parsePercentage.__workletHash = 8813932430184;
    parsePercentage.__stackDetails = _e;
    return parsePercentage;
}();
var names = (0, _core.makeShareable)({
    transparent: 0x00000000,
    aliceblue: 0xf0f8ffff,
    antiquewhite: 0xfaebd7ff,
    aqua: 0x00ffffff,
    aquamarine: 0x7fffd4ff,
    azure: 0xf0ffffff,
    beige: 0xf5f5dcff,
    bisque: 0xffe4c4ff,
    black: 0x000000ff,
    blanchedalmond: 0xffebcdff,
    blue: 0x0000ffff,
    blueviolet: 0x8a2be2ff,
    brown: 0xa52a2aff,
    burlywood: 0xdeb887ff,
    burntsienna: 0xea7e5dff,
    cadetblue: 0x5f9ea0ff,
    chartreuse: 0x7fff00ff,
    chocolate: 0xd2691eff,
    coral: 0xff7f50ff,
    cornflowerblue: 0x6495edff,
    cornsilk: 0xfff8dcff,
    crimson: 0xdc143cff,
    cyan: 0x00ffffff,
    darkblue: 0x00008bff,
    darkcyan: 0x008b8bff,
    darkgoldenrod: 0xb8860bff,
    darkgray: 0xa9a9a9ff,
    darkgreen: 0x006400ff,
    darkgrey: 0xa9a9a9ff,
    darkkhaki: 0xbdb76bff,
    darkmagenta: 0x8b008bff,
    darkolivegreen: 0x556b2fff,
    darkorange: 0xff8c00ff,
    darkorchid: 0x9932ccff,
    darkred: 0x8b0000ff,
    darksalmon: 0xe9967aff,
    darkseagreen: 0x8fbc8fff,
    darkslateblue: 0x483d8bff,
    darkslategray: 0x2f4f4fff,
    darkslategrey: 0x2f4f4fff,
    darkturquoise: 0x00ced1ff,
    darkviolet: 0x9400d3ff,
    deeppink: 0xff1493ff,
    deepskyblue: 0x00bfffff,
    dimgray: 0x696969ff,
    dimgrey: 0x696969ff,
    dodgerblue: 0x1e90ffff,
    firebrick: 0xb22222ff,
    floralwhite: 0xfffaf0ff,
    forestgreen: 0x228b22ff,
    fuchsia: 0xff00ffff,
    gainsboro: 0xdcdcdcff,
    ghostwhite: 0xf8f8ffff,
    gold: 0xffd700ff,
    goldenrod: 0xdaa520ff,
    gray: 0x808080ff,
    green: 0x008000ff,
    greenyellow: 0xadff2fff,
    grey: 0x808080ff,
    honeydew: 0xf0fff0ff,
    hotpink: 0xff69b4ff,
    indianred: 0xcd5c5cff,
    indigo: 0x4b0082ff,
    ivory: 0xfffff0ff,
    khaki: 0xf0e68cff,
    lavender: 0xe6e6faff,
    lavenderblush: 0xfff0f5ff,
    lawngreen: 0x7cfc00ff,
    lemonchiffon: 0xfffacdff,
    lightblue: 0xadd8e6ff,
    lightcoral: 0xf08080ff,
    lightcyan: 0xe0ffffff,
    lightgoldenrodyellow: 0xfafad2ff,
    lightgray: 0xd3d3d3ff,
    lightgreen: 0x90ee90ff,
    lightgrey: 0xd3d3d3ff,
    lightpink: 0xffb6c1ff,
    lightsalmon: 0xffa07aff,
    lightseagreen: 0x20b2aaff,
    lightskyblue: 0x87cefaff,
    lightslategray: 0x778899ff,
    lightslategrey: 0x778899ff,
    lightsteelblue: 0xb0c4deff,
    lightyellow: 0xffffe0ff,
    lime: 0x00ff00ff,
    limegreen: 0x32cd32ff,
    linen: 0xfaf0e6ff,
    magenta: 0xff00ffff,
    maroon: 0x800000ff,
    mediumaquamarine: 0x66cdaaff,
    mediumblue: 0x0000cdff,
    mediumorchid: 0xba55d3ff,
    mediumpurple: 0x9370dbff,
    mediumseagreen: 0x3cb371ff,
    mediumslateblue: 0x7b68eeff,
    mediumspringgreen: 0x00fa9aff,
    mediumturquoise: 0x48d1ccff,
    mediumvioletred: 0xc71585ff,
    midnightblue: 0x191970ff,
    mintcream: 0xf5fffaff,
    mistyrose: 0xffe4e1ff,
    moccasin: 0xffe4b5ff,
    navajowhite: 0xffdeadff,
    navy: 0x000080ff,
    oldlace: 0xfdf5e6ff,
    olive: 0x808000ff,
    olivedrab: 0x6b8e23ff,
    orange: 0xffa500ff,
    orangered: 0xff4500ff,
    orchid: 0xda70d6ff,
    palegoldenrod: 0xeee8aaff,
    palegreen: 0x98fb98ff,
    paleturquoise: 0xafeeeeff,
    palevioletred: 0xdb7093ff,
    papayawhip: 0xffefd5ff,
    peachpuff: 0xffdab9ff,
    peru: 0xcd853fff,
    pink: 0xffc0cbff,
    plum: 0xdda0ddff,
    powderblue: 0xb0e0e6ff,
    purple: 0x800080ff,
    rebeccapurple: 0x663399ff,
    red: 0xff0000ff,
    rosybrown: 0xbc8f8fff,
    royalblue: 0x4169e1ff,
    saddlebrown: 0x8b4513ff,
    salmon: 0xfa8072ff,
    sandybrown: 0xf4a460ff,
    seagreen: 0x2e8b57ff,
    seashell: 0xfff5eeff,
    sienna: 0xa0522dff,
    silver: 0xc0c0c0ff,
    skyblue: 0x87ceebff,
    slateblue: 0x6a5acdff,
    slategray: 0x708090ff,
    slategrey: 0x708090ff,
    snow: 0xfffafaff,
    springgreen: 0x00ff7fff,
    steelblue: 0x4682b4ff,
    tan: 0xd2b48cff,
    teal: 0x008080ff,
    thistle: 0xd8bfd8ff,
    tomato: 0xff6347ff,
    turquoise: 0x40e0d0ff,
    violet: 0xee82eeff,
    wheat: 0xf5deb3ff,
    white: 0xffffffff,
    whitesmoke: 0xf5f5f5ff,
    yellow: 0xffff00ff,
    yellowgreen: 0x9acd32ff
});
var ColorProperties = exports.ColorProperties = (0, _core.makeShareable)([
    "backgroundColor",
    "borderBottomColor",
    "borderColor",
    "borderLeftColor",
    "borderRightColor",
    "borderTopColor",
    "borderStartColor",
    "borderEndColor",
    "borderBlockColor",
    "borderBlockEndColor",
    "borderBlockStartColor",
    "color",
    "shadowColor",
    "textDecorationColor",
    "tintColor",
    "textShadowColor",
    "overlayColor"
]);
var _worklet_3094355228222_init_data = {
    code: "function normalizeColor(color){const{MATCHERS,names,parse255,parse1,hslToRgb,parse360,parsePercentage}=this.__closure;if(typeof color==='number'){if(color>>>0===color&&color>=0&&color<=0xffffffff){return color;}return null;}if(typeof color!=='string'){return null;}let match;if(match=MATCHERS.hex6.exec(color)){return Number.parseInt(match[1]+'ff',16)>>>0;}if(names[color]!==undefined){return names[color];}if(match=MATCHERS.rgb.exec(color)){return(parse255(match[1])<<24|parse255(match[2])<<16|parse255(match[3])<<8|0x000000ff)>>>0;}if(match=MATCHERS.rgba.exec(color)){return(parse255(match[1])<<24|parse255(match[2])<<16|parse255(match[3])<<8|parse1(match[4]))>>>0;}if(match=MATCHERS.hex3.exec(color)){return Number.parseInt(match[1]+match[1]+match[2]+match[2]+match[3]+match[3]+'ff',16)>>>0;}if(match=MATCHERS.hex8.exec(color)){return Number.parseInt(match[1],16)>>>0;}if(match=MATCHERS.hex4.exec(color)){return Number.parseInt(match[1]+match[1]+match[2]+match[2]+match[3]+match[3]+match[4]+match[4],16)>>>0;}if(match=MATCHERS.hsl.exec(color)){return(hslToRgb(parse360(match[1]),parsePercentage(match[2]),parsePercentage(match[3]))|0x000000ff)>>>0;}if(match=MATCHERS.hsla.exec(color)){return(hslToRgb(parse360(match[1]),parsePercentage(match[2]),parsePercentage(match[3]))|parse1(match[4]))>>>0;}return null;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["normalizeColor","color","MATCHERS","names","parse255","parse1","hslToRgb","parse360","parsePercentage","__closure","match","hex6","exec","Number","parseInt","undefined","rgb","rgba","hex3","hex8","hex4","hsl","hsla"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA0SA,SAAAA,cAASA,CAAeC,KAAA,CAAe,OAAAC,QAAA,CAAAC,KAAA,CAAAC,QAAA,CAAAC,MAAA,CAAAC,QAAA,CAAAC,QAAA,CAAAC,eAAA,OAAAC,SAAA,CAGrC,GAAI,MAAO,CAAAR,KAAK,GAAK,QAAQ,CAAE,CAC7B,GAAIA,KAAK,GAAK,CAAC,GAAKA,KAAK,EAAIA,KAAK,EAAI,CAAC,EAAIA,KAAK,EAAI,UAAU,CAAE,CAC9D,MAAO,CAAAA,KAAK,CACd,CACA,MAAO,KAAI,CACb,CAEA,GAAI,MAAO,CAAAA,KAAK,GAAK,QAAQ,CAAE,CAC7B,MAAO,KAAI,CACb,CAEA,GAAI,CAAAS,KAAyC,CAG7C,GAAKA,KAAK,CAAGR,QAAQ,CAACS,IAAI,CAACC,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MAAO,CAAAY,MAAM,CAACC,QAAQ,CAACJ,KAAK,CAAC,CAAC,CAAC,CAAG,IAAI,CAAE,EAAE,CAAC,GAAK,CAAC,CACnD,CAEA,GAAIP,KAAK,CAACF,KAAK,CAAC,GAAKc,SAAS,CAAE,CAC9B,MAAO,CAAAZ,KAAK,CAACF,KAAK,CAAC,CACrB,CAEA,GAAKS,KAAK,CAAGR,QAAQ,CAACc,GAAG,CAACJ,IAAI,CAACX,KAAK,CAAC,CAAG,CACtC,MAEE,CAAEG,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,EAAE,CACvBN,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,EAAG,CACzBN,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,CAAE,CACzB,UAAU,IACZ,EAEJ,CAEA,GAAKA,KAAK,CAAGR,QAAQ,CAACe,IAAI,CAACL,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MAEE,CAAEG,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,EAAE,CACvBN,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,EAAG,CACzBN,QAAQ,CAACM,KAAK,CAAC,CAAC,CAAC,CAAC,EAAI,CAAE,CACzBL,MAAM,CAACK,KAAK,CAAC,CAAC,CAAC,CAAC,IAClB,EAEJ,CAEA,GAAKA,KAAK,CAAGR,QAAQ,CAACgB,IAAI,CAACN,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MACE,CAAAY,MAAM,CAACC,QAAQ,CACbJ,KAAK,CAAC,CAAC,CAAC,CACNA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACR,IAAI,CACN,EACF,CAAC,GAAK,CAAC,CAEX,CAGA,GAAKA,KAAK,CAAGR,QAAQ,CAACiB,IAAI,CAACP,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MAAO,CAAAY,MAAM,CAACC,QAAQ,CAACJ,KAAK,CAAC,CAAC,CAAC,CAAE,EAAE,CAAC,GAAK,CAAC,CAC5C,CAEA,GAAKA,KAAK,CAAGR,QAAQ,CAACkB,IAAI,CAACR,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MACE,CAAAY,MAAM,CAACC,QAAQ,CACbJ,KAAK,CAAC,CAAC,CAAC,CACNA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACRA,KAAK,CAAC,CAAC,CAAC,CACV,EACF,CAAC,GAAK,CAAC,CAEX,CAEA,GAAKA,KAAK,CAAGR,QAAQ,CAACmB,GAAG,CAACT,IAAI,CAACX,KAAK,CAAC,CAAG,CACtC,MACE,CAACK,QAAQ,CACPC,QAAQ,CAACG,KAAK,CAAC,CAAC,CAAC,CAAC,CAClBF,eAAe,CAACE,KAAK,CAAC,CAAC,CAAC,CAAC,CACzBF,eAAe,CAACE,KAAK,CAAC,CAAC,CAAC,CAC1B,CAAC,CACC,UAAU,IACZ,CAAC,CAEL,CAEA,GAAKA,KAAK,CAAGR,QAAQ,CAACoB,IAAI,CAACV,IAAI,CAACX,KAAK,CAAC,CAAG,CACvC,MACE,CAACK,QAAQ,CACPC,QAAQ,CAACG,KAAK,CAAC,CAAC,CAAC,CAAC,CAClBF,eAAe,CAACE,KAAK,CAAC,CAAC,CAAC,CAAC,CACzBF,eAAe,CAACE,KAAK,CAAC,CAAC,CAAC,CAC1B,CAAC,CACCL,MAAM,CAACK,KAAK,CAAC,CAAC,CAAC,CAAC,IAClB,CAAC,CAEL,CAEA,MAAO,KAAI,CACb"}',
    version: "3.5.4"
};
var normalizeColor = function() {
    var _e = [
        new global.Error(),
        -8,
        -27
    ];
    var normalizeColor = function normalizeColor(color) {
        if (typeof color === "number") {
            if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
                return color;
            }
            return null;
        }
        if (typeof color !== "string") {
            return null;
        }
        var match;
        if (match = MATCHERS.hex6.exec(color)) {
            return Number.parseInt(match[1] + "ff", 16) >>> 0;
        }
        if (names[color] !== undefined) {
            return names[color];
        }
        if (match = MATCHERS.rgb.exec(color)) {
            return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | 0x000000ff) >>> 0;
        }
        if (match = MATCHERS.rgba.exec(color)) {
            return (parse255(match[1]) << 24 | parse255(match[2]) << 16 | parse255(match[3]) << 8 | parse1(match[4])) >>> 0;
        }
        if (match = MATCHERS.hex3.exec(color)) {
            return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + "ff", 16) >>> 0;
        }
        if (match = MATCHERS.hex8.exec(color)) {
            return Number.parseInt(match[1], 16) >>> 0;
        }
        if (match = MATCHERS.hex4.exec(color)) {
            return Number.parseInt(match[1] + match[1] + match[2] + match[2] + match[3] + match[3] + match[4] + match[4], 16) >>> 0;
        }
        if (match = MATCHERS.hsl.exec(color)) {
            return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | 0x000000ff) >>> 0;
        }
        if (match = MATCHERS.hsla.exec(color)) {
            return (hslToRgb(parse360(match[1]), parsePercentage(match[2]), parsePercentage(match[3])) | parse1(match[4])) >>> 0;
        }
        return null;
    };
    normalizeColor.__closure = {
        MATCHERS: MATCHERS,
        names: names,
        parse255: parse255,
        parse1: parse1,
        hslToRgb: hslToRgb,
        parse360: parse360,
        parsePercentage: parsePercentage
    };
    normalizeColor.__initData = _worklet_3094355228222_init_data;
    normalizeColor.__workletHash = 3094355228222;
    normalizeColor.__stackDetails = _e;
    return normalizeColor;
}();
var _worklet_15550450801870_init_data = {
    code: "function anonymous(c){return(c>>24&255)/255;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","c"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAwZuB,QAAC,CAAAA,SAAsBA,CAAAC,CAAA,EAE5C,MAAO,CAAEA,CAAC,EAAI,EAAE,CAAI,GAAG,EAAI,GAAG,CAChC"}',
    version: "3.5.4"
};
var opacity = exports.opacity = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(c) {
        return (c >> 24 & 255) / 255;
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_15550450801870_init_data;
    anonymous.__workletHash = 15550450801870;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_9095050284307_init_data = {
    code: "function anonymous(c){return c>>16&255;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","c"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA6ZmB,QAAC,CAAAA,SAAsBA,CAAAC,CAAA,EAExC,MAAQ,CAAAA,CAAC,EAAI,EAAE,CAAI,GAAG,CACxB"}',
    version: "3.5.4"
};
var red = exports.red = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(c) {
        return c >> 16 & 255;
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_9095050284307_init_data;
    anonymous.__workletHash = 9095050284307;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_5168419980876_init_data = {
    code: "function anonymous(c){return c>>8&255;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","c"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAkaqB,QAAC,CAAAA,SAAsBA,CAAAC,CAAA,EAE1C,MAAQ,CAAAA,CAAC,EAAI,CAAC,CAAI,GAAG,CACvB"}',
    version: "3.5.4"
};
var green = exports.green = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(c) {
        return c >> 8 & 255;
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_5168419980876_init_data;
    anonymous.__workletHash = 5168419980876;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_8366976340820_init_data = {
    code: "function anonymous(c){return c&255;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","c"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAuaoB,QAAC,CAAAA,SAAsBA,CAAAC,CAAA,EAEzC,MAAO,CAAAA,CAAC,CAAG,GAAG,CAChB"}',
    version: "3.5.4"
};
var blue = exports.blue = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var anonymous = function anonymous(c) {
        return c & 255;
    };
    anonymous.__closure = {};
    anonymous.__initData = _worklet_8366976340820_init_data;
    anonymous.__workletHash = 8366976340820;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var IS_WEB = (0, _PlatformChecker.isWeb)();
var IS_ANDROID = (0, _PlatformChecker.isAndroid)();
var _worklet_913795021117_init_data = {
    code: 'function anonymous(r,g,b,alpha=1){const{IS_WEB,IS_ANDROID}=this.__closure;if(IS_WEB||!_WORKLET){return"rgba("+r+", "+g+", "+b+", "+alpha+")";}const c=Math.round(alpha*255)*(1<<24)+Math.round(r)*(1<<16)+Math.round(g)*(1<<8)+Math.round(b);if(IS_ANDROID){return c<1<<31>>>0?c:c-4294967296;}return c;}',
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","r","g","b","alpha","IS_WEB","IS_ANDROID","__closure","_WORKLET","c","Math","round"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA+ayB,QACvB,CAAAA,SAESA,CAAAC,CACT,CAAAC,CAAA,CAAKC,CAAA,CAAIC,KACW,UAAAC,MAAA,CAAAC,UAAA,OAAAC,SAAA,CAEpB,GAAIF,MAAM,EAAI,CAACG,QAAQ,CAAE,CACvB,cAAeP,CAAE,MAAIC,CAAE,MAAIC,CAAE,MAAIC,KAAM,KACzC,CAEA,KAAM,CAAAK,CAAC,CACLC,IAAI,CAACC,KAAK,CAACP,KAAK,CAAG,GAAG,CAAC,EAAI,CAAC,EAAI,EAAE,CAAC,CACnCM,IAAI,CAACC,KAAK,CAACV,CAAC,CAAC,EAAI,CAAC,EAAI,EAAE,CAAC,CACzBS,IAAI,CAACC,KAAK,CAACT,CAAC,CAAC,EAAI,CAAC,EAAI,CAAC,CAAC,CACxBQ,IAAI,CAACC,KAAK,CAACR,CAAC,CAAC,CACf,GAAIG,UAAU,CAAE,CAEd,MAAO,CAAAG,CAAC,CAAI,CAAC,EAAI,EAAE,GAAM,CAAC,CAAGA,CAAC,CAAGA,CAAC,CAAG,UAAU,CACjD,CACA,MAAO,CAAAA,CAAC,CACV"}',
    version: "3.5.4"
};
var rgbaColor = exports.rgbaColor = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var anonymous = function anonymous(r, g, b) {
        var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
        if (IS_WEB || !_WORKLET) {
            return "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(alpha, ")");
        }
        var c = Math.round(alpha * 255) * (1 << 24) + Math.round(r) * (1 << 16) + Math.round(g) * (1 << 8) + Math.round(b);
        if (IS_ANDROID) {
            return c < 1 << 31 >>> 0 ? c : c - 4294967296;
        }
        return c;
    };
    anonymous.__closure = {
        IS_WEB: IS_WEB,
        IS_ANDROID: IS_ANDROID
    };
    anonymous.__initData = _worklet_913795021117_init_data;
    anonymous.__workletHash = 913795021117;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_16546486427681_init_data = {
    code: "function RGBtoHSV(r,g,b){if(arguments.length===1){g=r.g;b=r.b;r=r.r;}const max=Math.max(r,g,b);const min=Math.min(r,g,b);const d=max-min;const s=max===0?0:d/max;const v=max/255;let h;switch(max){default:case min:h=0;break;case r:h=g-b+d*(g<b?6:0);h/=6*d;break;case g:h=b-r+d*2;h/=6*d;break;case b:h=r-g+d*4;h/=6*d;break;}return{h:h,s:s,v:v};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["RGBtoHSV","r","g","b","arguments","length","max","Math","min","d","s","v","h"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA+cO,SAAAA,QAASA,CAASC,CAAC,CAAKC,CAAS,CAAAC,CAAS,CAAC,CAGhD,GAAIC,SAAS,CAACC,MAAM,GAAK,CAAC,CAAE,CAC1BH,CAAC,CAAGD,CAAC,CAACC,CAAC,CACPC,CAAC,CAAGF,CAAC,CAACE,CAAC,CACPF,CAAC,CAAGA,CAAC,CAACA,CAAC,CACT,CACA,KAAM,CAAAK,GAAG,CAAGC,IAAI,CAACD,GAAG,CAACL,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAC,CAC7B,KAAM,CAAAK,GAAG,CAAGD,IAAI,CAACC,GAAG,CAACP,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAC,CAC7B,KAAM,CAAAM,CAAC,CAAGH,GAAG,CAAGE,GAAG,CACnB,KAAM,CAAAE,CAAC,CAAGJ,GAAG,GAAK,CAAC,CAAG,CAAC,CAAGG,CAAC,CAAGH,GAAG,CACjC,KAAM,CAAAK,CAAC,CAAGL,GAAG,CAAG,GAAG,CAEnB,GAAI,CAAAM,CAAC,CAEL,OAAQN,GAAG,EACT,QAEA,IAAK,CAAAE,GAAG,CACNI,CAAC,CAAG,CAAC,CACL,MACF,IAAK,CAAAX,CAAC,CACJW,CAAC,CAAGV,CAAC,CAAGC,CAAC,CAAGM,CAAC,EAAIP,CAAC,CAAGC,CAAC,CAAG,CAAC,CAAG,CAAC,CAAC,CAC/BS,CAAC,EAAI,CAAC,CAAGH,CAAC,CACV,MACF,IAAK,CAAAP,CAAC,CACJU,CAAC,CAAGT,CAAC,CAAGF,CAAC,CAAGQ,CAAC,CAAG,CAAC,CACjBG,CAAC,EAAI,CAAC,CAAGH,CAAC,CACV,MACF,IAAK,CAAAN,CAAC,CACJS,CAAC,CAAGX,CAAC,CAAGC,CAAC,CAAGO,CAAC,CAAG,CAAC,CACjBG,CAAC,EAAI,CAAC,CAAGH,CAAC,CACV,MACJ,CAEA,MAAO,CACLG,CAAC,CAAEA,CAAC,CACJF,CAAC,CAAEA,CAAC,CACJC,CAAC,CAAEA,CACL,CAAC,CAEH"}',
    version: "3.5.4"
};
var RGBtoHSV = exports.RGBtoHSV = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var RGBtoHSV = function RGBtoHSV(r, g, b) {
        if (arguments.length === 1) {
            g = r.g;
            b = r.b;
            r = r.r;
        }
        var max = Math.max(r, g, b);
        var min = Math.min(r, g, b);
        var d = max - min;
        var s = max === 0 ? 0 : d / max;
        var v = max / 255;
        var h;
        switch(max){
            default:
            case min:
                h = 0;
                break;
            case r:
                h = g - b + d * (g < b ? 6 : 0);
                h /= 6 * d;
                break;
            case g:
                h = b - r + d * 2;
                h /= 6 * d;
                break;
            case b:
                h = r - g + d * 4;
                h /= 6 * d;
                break;
        }
        return {
            h: h,
            s: s,
            v: v
        };
    };
    RGBtoHSV.__closure = {};
    RGBtoHSV.__initData = _worklet_16546486427681_init_data;
    RGBtoHSV.__workletHash = 16546486427681;
    RGBtoHSV.__stackDetails = _e;
    return RGBtoHSV;
}();
var _worklet_8891027662548_init_data = {
    code: "function HSVtoRGB(h,s,v){var r,g,b,i,f,p,q,t;if(arguments.length===1){s=h.s;v=h.v;h=h.h;}i=Math.floor(h*6);f=h*6-i;p=v*(1-s);q=v*(1-f*s);t=v*(1-(1-f)*s);switch(i%6){case 0:r=v,g=t,b=p;break;case 1:r=q,g=v,b=p;break;case 2:r=p,g=v,b=t;break;case 3:r=p,g=q,b=v;break;case 4:r=t,g=p,b=v;break;case 5:r=v,g=p,b=q;break;}return{r:Math.round(r*255),g:Math.round(g*255),b:Math.round(b*255)};}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["HSVtoRGB","h","s","v","r","g","b","i","f","p","q","t","arguments","length","Math","floor","round"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAogBA,SAAAA,QAASA,CAASC,CAAC,CAAKC,CAAS,CAAAC,CAAS,EAGxC,GAAI,CAAAC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAC1B,GAAIC,SAAS,CAACC,MAAM,GAAK,CAAC,CAAE,CAC1BX,CAAC,CAAGD,CAAC,CAACC,CAAC,CACPC,CAAC,CAAGF,CAAC,CAACE,CAAC,CACPF,CAAC,CAAGA,CAAC,CAACA,CAAC,CACT,CACAM,CAAC,CAAGO,IAAI,CAACC,KAAK,CAACd,CAAC,CAAG,CAAC,CAAC,CACrBO,CAAC,CAAGP,CAAC,CAAG,CAAC,CAAGM,CAAC,CACbE,CAAC,CAAGN,CAAC,EAAI,CAAC,CAAGD,CAAC,CAAC,CACfQ,CAAC,CAAGP,CAAC,EAAI,CAAC,CAAGK,CAAC,CAAGN,CAAC,CAAC,CACnBS,CAAC,CAAGR,CAAC,EAAI,CAAC,CAAG,CAAC,CAAC,CAAGK,CAAC,EAAIN,CAAC,CAAC,CACzB,OAAQK,CAAC,CAAG,CAAC,EACX,IAAK,EAAC,CACHH,CAAC,CAAGD,CAAC,CAAIE,CAAC,CAAGM,CAAC,CAAIL,CAAC,CAAGG,CAAE,CACzB,MACF,IAAK,EAAC,CACHL,CAAC,CAAGM,CAAC,CAAIL,CAAC,CAAGF,CAAC,CAAIG,CAAC,CAAGG,CAAE,CACzB,MACF,IAAK,EAAC,CACHL,CAAC,CAAGK,CAAC,CAAIJ,CAAC,CAAGF,CAAC,CAAIG,CAAC,CAAGK,CAAE,CACzB,MACF,IAAK,EAAC,CACHP,CAAC,CAAGK,CAAC,CAAIJ,CAAC,CAAGK,CAAC,CAAIJ,CAAC,CAAGH,CAAE,CACzB,MACF,IAAK,EAAC,CACHC,CAAC,CAAGO,CAAC,CAAIN,CAAC,CAAGI,CAAC,CAAIH,CAAC,CAAGH,CAAE,CACzB,MACF,IAAK,EAAC,CACHC,CAAC,CAAGD,CAAC,CAAIE,CAAC,CAAGI,CAAC,CAAIH,CAAC,CAAGI,CAAE,CACzB,MACJ,CACA,MAAO,CACLN,CAAC,CAAEU,IAAI,CAACE,KAAK,CAACZ,CAAC,CAAG,GAAG,CAAC,CACtBC,CAAC,CAAES,IAAI,CAACE,KAAK,CAACX,CAAC,CAAG,GAAG,CAAC,CACtBC,CAAC,CAAEQ,IAAI,CAACE,KAAK,CAACV,CAAC,CAAG,GAAG,CACvB,CAAC,CAEH"}',
    version: "3.5.4"
};
var HSVtoRGB = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var HSVtoRGB = function HSVtoRGB(h, s, v) {
        var r, g, b, i, f, p, q, t;
        if (arguments.length === 1) {
            s = h.s;
            v = h.v;
            h = h.h;
        }
        i = Math.floor(h * 6);
        f = h * 6 - i;
        p = v * (1 - s);
        q = v * (1 - f * s);
        t = v * (1 - (1 - f) * s);
        switch(i % 6){
            case 0:
                r = v, g = t, b = p;
                break;
            case 1:
                r = q, g = v, b = p;
                break;
            case 2:
                r = p, g = v, b = t;
                break;
            case 3:
                r = p, g = q, b = v;
                break;
            case 4:
                r = t, g = p, b = v;
                break;
            case 5:
                r = v, g = p, b = q;
                break;
        }
        return {
            r: Math.round(r * 255),
            g: Math.round(g * 255),
            b: Math.round(b * 255)
        };
    };
    HSVtoRGB.__closure = {};
    HSVtoRGB.__initData = _worklet_8891027662548_init_data;
    HSVtoRGB.__workletHash = 8891027662548;
    HSVtoRGB.__stackDetails = _e;
    return HSVtoRGB;
}();
var _worklet_12352805471800_init_data = {
    code: "function anonymous(h,s,v,a){const{HSVtoRGB,rgbaColor}=this.__closure;const{r:r,g:g,b:b}=HSVtoRGB(h,s,v);return rgbaColor(r,g,b,a);}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["anonymous","h","s","v","a","HSVtoRGB","rgbaColor","__closure","r","g","b"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA8iB0B,QACxB,CAAAA,SAESA,CAAAC,CACR,CACFC,CAAqB,CAAAC,CAAA,CAAAC,CAAA,QAAAC,QAAA,CAAAC,SAAA,OAAAC,SAAA,CAEpB,KAAM,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAC,CAADA,CAAC,CAAEC,CAAA,CAAAA,CAAE,CAAC,CAAGL,QAAQ,CAACJ,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAC,CACrC,MAAO,CAAAG,SAAS,CAACE,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEN,CAAC,CAAC,CAC9B"}',
    version: "3.5.4"
};
var hsvToColor = exports.hsvToColor = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var anonymous = function anonymous(h, s, v, a) {
        var _HSVtoRGB = HSVtoRGB(h, s, v), r = _HSVtoRGB.r, g = _HSVtoRGB.g, b = _HSVtoRGB.b;
        return rgbaColor(r, g, b, a);
    };
    anonymous.__closure = {
        HSVtoRGB: HSVtoRGB,
        rgbaColor: rgbaColor
    };
    anonymous.__initData = _worklet_12352805471800_init_data;
    anonymous.__workletHash = 12352805471800;
    anonymous.__stackDetails = _e;
    return anonymous;
}();
var _worklet_12569865430969_init_data = {
    code: "function processColorInitially(color){const{normalizeColor}=this.__closure;if(color===null||color===undefined||typeof color==='number'){return color;}let normalizedColor=normalizeColor(color);if(normalizedColor===null||normalizedColor===undefined){return undefined;}if(typeof normalizedColor!=='number'){return null;}normalizedColor=(normalizedColor<<24|normalizedColor>>>8)>>>0;return normalizedColor;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["processColorInitially","color","normalizeColor","__closure","undefined","normalizedColor"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAyjBA,SAAAA,qBAASA,CAAsBC,KAAA,CAAe,OAAAC,cAAA,OAAAC,SAAA,CAE5C,GAAIF,KAAK,GAAK,IAAI,EAAIA,KAAK,GAAKG,SAAS,EAAI,MAAO,CAAAH,KAAK,GAAK,QAAQ,CAAE,CACtE,MAAO,CAAAA,KAAK,CACd,CAEA,GAAI,CAAAI,eAAe,CAAGH,cAAc,CAACD,KAAK,CAAC,CAE3C,GAAII,eAAe,GAAK,IAAI,EAAIA,eAAe,GAAKD,SAAS,CAAE,CAC7D,MAAO,CAAAA,SAAS,CAClB,CAEA,GAAI,MAAO,CAAAC,eAAe,GAAK,QAAQ,CAAE,CACvC,MAAO,KAAI,CACb,CAEAA,eAAe,CAAG,CAAEA,eAAe,EAAI,EAAE,CAAKA,eAAe,GAAK,CAAE,IAAM,CAAC,CAC3E,MAAO,CAAAA,eAAe,CACxB"}',
    version: "3.5.4"
};
var processColorInitially = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var processColorInitially = function processColorInitially(color) {
        if (color === null || color === undefined || typeof color === "number") {
            return color;
        }
        var normalizedColor = normalizeColor(color);
        if (normalizedColor === null || normalizedColor === undefined) {
            return undefined;
        }
        if (typeof normalizedColor !== "number") {
            return null;
        }
        normalizedColor = (normalizedColor << 24 | normalizedColor >>> 8) >>> 0;
        return normalizedColor;
    };
    processColorInitially.__closure = {
        normalizeColor: normalizeColor
    };
    processColorInitially.__initData = _worklet_12569865430969_init_data;
    processColorInitially.__workletHash = 12569865430969;
    processColorInitially.__stackDetails = _e;
    return processColorInitially;
}();
var _worklet_5088329737380_init_data = {
    code: "function isColor(value){const{processColorInitially}=this.__closure;if(typeof value!=='string'){return false;}return processColorInitially(value)!=null;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["isColor","value","processColorInitially","__closure"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA6kBO,SAAAA,OAASA,CAAQC,KAAA,CAAe,OAAAC,qBAAA,OAAAC,SAAA,CAErC,GAAI,MAAO,CAAAF,KAAK,GAAK,QAAQ,CAAE,CAC7B,MAAO,MAAK,CACd,CACA,MAAO,CAAAC,qBAAqB,CAACD,KAAK,CAAC,EAAI,IAAI,CAC7C"}',
    version: "3.5.4"
};
var isColor = exports.isColor = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var isColor = function isColor(value) {
        if (typeof value !== "string") {
            return false;
        }
        return processColorInitially(value) != null;
    };
    isColor.__closure = {
        processColorInitially: processColorInitially
    };
    isColor.__initData = _worklet_5088329737380_init_data;
    isColor.__workletHash = 5088329737380;
    isColor.__stackDetails = _e;
    return isColor;
}();
var _worklet_16463857542154_init_data = {
    code: "function processColor(color){const{processColorInitially,IS_ANDROID}=this.__closure;let normalizedColor=processColorInitially(color);if(normalizedColor===null||normalizedColor===undefined){return undefined;}if(typeof normalizedColor!=='number'){return null;}if(IS_ANDROID){normalizedColor=normalizedColor|0x0;}return normalizedColor;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["processColor","color","processColorInitially","IS_ANDROID","__closure","normalizedColor","undefined"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAqlBO,SAAAA,YAASA,CAAaC,KAAA,CAAe,OAAAC,qBAAA,CAAAC,UAAA,OAAAC,SAAA,CAE1C,GAAI,CAAAC,eAAe,CAAGH,qBAAqB,CAACD,KAAK,CAAC,CAClD,GAAII,eAAe,GAAK,IAAI,EAAIA,eAAe,GAAKC,SAAS,CAAE,CAC7D,MAAO,CAAAA,SAAS,CAClB,CAEA,GAAI,MAAO,CAAAD,eAAe,GAAK,QAAQ,CAAE,CACvC,MAAO,KAAI,CACb,CAEA,GAAIF,UAAU,CAAE,CAKdE,eAAe,CAAGA,eAAe,CAAG,GAAG,CACzC,CAEA,MAAO,CAAAA,eAAe,CACxB"}',
    version: "3.5.4"
};
var processColor = exports.processColor = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var processColor = function processColor(color) {
        var normalizedColor = processColorInitially(color);
        if (normalizedColor === null || normalizedColor === undefined) {
            return undefined;
        }
        if (typeof normalizedColor !== "number") {
            return null;
        }
        if (IS_ANDROID) {
            normalizedColor = normalizedColor | 0x0;
        }
        return normalizedColor;
    };
    processColor.__closure = {
        processColorInitially: processColorInitially,
        IS_ANDROID: IS_ANDROID
    };
    processColor.__initData = _worklet_16463857542154_init_data;
    processColor.__workletHash = 16463857542154;
    processColor.__stackDetails = _e;
    return processColor;
}();
var _worklet_17572150472143_init_data = {
    code: "function processColorsInProps(props){const{ColorProperties,processColor}=this.__closure;for(const key in props){if(ColorProperties.includes(key)){props[key]=processColor(props[key]);}}}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["processColorsInProps","props","ColorProperties","processColor","__closure","key","includes"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AA2mBO,SAAAA,oBAASA,CAAqBC,KAAA,CAAiB,OAAAC,eAAA,CAAAC,YAAA,OAAAC,SAAA,CAEpD,IAAK,KAAM,CAAAC,GAAG,GAAI,CAAAJ,KAAK,CAAE,CACvB,GAAIC,eAAe,CAACI,QAAQ,CAACD,GAAG,CAAC,CAAE,CACjCJ,KAAK,CAACI,GAAG,CAAC,CAAGF,YAAY,CAACF,KAAK,CAACI,GAAG,CAAC,CAAC,CACvC,CACF,CACF"}',
    version: "3.5.4"
};
var processColorsInProps = exports.processColorsInProps = function() {
    var _e = [
        new global.Error(),
        -3,
        -27
    ];
    var processColorsInProps = function processColorsInProps(props) {
        for(var key in props){
            if (ColorProperties.includes(key)) {
                props[key] = processColor(props[key]);
            }
        }
    };
    processColorsInProps.__closure = {
        ColorProperties: ColorProperties,
        processColor: processColor
    };
    processColorsInProps.__initData = _worklet_17572150472143_init_data;
    processColorsInProps.__workletHash = 17572150472143;
    processColorsInProps.__stackDetails = _e;
    return processColorsInProps;
}();
var _worklet_17431876032755_init_data = {
    code: "function convertToRGBA(color){const{processColorInitially}=this.__closure;const processedColor=processColorInitially(color);const a=(processedColor>>>24)/255;const r=(processedColor<<8>>>24)/255;const g=(processedColor<<16>>>24)/255;const b=(processedColor<<24>>>24)/255;return[r,g,b,a];}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["convertToRGBA","color","processColorInitially","__closure","processedColor","a","r","g","b"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAsnBO,SAAAA,aAASA,CAAcC,KAAA,CAAe,OAAAC,qBAAA,OAAAC,SAAA,CAE3C,KAAM,CAAAC,cAAc,CAAGF,qBAAqB,CAACD,KAAK,CAAE,CACpD,KAAM,CAAAI,CAAC,CAAG,CAACD,cAAc,GAAK,EAAE,EAAI,GAAG,CACvC,KAAM,CAAAE,CAAC,CAAG,CAAEF,cAAc,EAAI,CAAC,GAAM,EAAE,EAAI,GAAG,CAC9C,KAAM,CAAAG,CAAC,CAAG,CAAEH,cAAc,EAAI,EAAE,GAAM,EAAE,EAAI,GAAG,CAC/C,KAAM,CAAAI,CAAC,CAAG,CAAEJ,cAAc,EAAI,EAAE,GAAM,EAAE,EAAI,GAAG,CAC/C,MAAO,CAACE,CAAC,CAAEC,CAAC,CAAEC,CAAC,CAAEH,CAAC,CAAC,CACrB"}',
    version: "3.5.4"
};
var convertToRGBA = exports.convertToRGBA = function() {
    var _e = [
        new global.Error(),
        -2,
        -27
    ];
    var convertToRGBA = function convertToRGBA(color) {
        var processedColor = processColorInitially(color);
        var a = (processedColor >>> 24) / 255;
        var r = (processedColor << 8 >>> 24) / 255;
        var g = (processedColor << 16 >>> 24) / 255;
        var b = (processedColor << 24 >>> 24) / 255;
        return [
            r,
            g,
            b,
            a
        ];
    };
    convertToRGBA.__closure = {
        processColorInitially: processColorInitially
    };
    convertToRGBA.__initData = _worklet_17431876032755_init_data;
    convertToRGBA.__workletHash = 17431876032755;
    convertToRGBA.__stackDetails = _e;
    return convertToRGBA;
}();
var _worklet_1218651315844_init_data = {
    code: 'function rgbaArrayToRGBAColor(RGBA){return"rgba("+Math.round(RGBA[0]*255)+", "+Math.round(RGBA[1]*255)+", "+Math.round(RGBA[2]*255)+", "+RGBA[3]+")";}',
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["rgbaArrayToRGBAColor","RGBA","Math","round"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAgoBO,SAAAA,oBAASA,CAAqBC,IAAA,CAAuB,CAE1D,cAAeC,IAAI,CAACC,KAAK,CAACF,IAAI,CAAC,CAAC,CAAC,CAAG,GAAG,CAAE,MAAIC,IAAI,CAACC,KAAK,CACrDF,IAAI,CAAC,CAAC,CAAC,CAAG,GACZ,CAAE,MAAIC,IAAI,CAACC,KAAK,CAACF,IAAI,CAAC,CAAC,CAAC,CAAG,GAAG,CAAE,MAAIA,IAAI,CAAC,CAAC,CAAE,KAC9C"}',
    version: "3.5.4"
};
var rgbaArrayToRGBAColor = exports.rgbaArrayToRGBAColor = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var rgbaArrayToRGBAColor = function rgbaArrayToRGBAColor(RGBA) {
        return "rgba(".concat(Math.round(RGBA[0] * 255), ", ").concat(Math.round(RGBA[1] * 255), ", ").concat(Math.round(RGBA[2] * 255), ", ").concat(RGBA[3], ")");
    };
    rgbaArrayToRGBAColor.__closure = {};
    rgbaArrayToRGBAColor.__initData = _worklet_1218651315844_init_data;
    rgbaArrayToRGBAColor.__workletHash = 1218651315844;
    rgbaArrayToRGBAColor.__stackDetails = _e;
    return rgbaArrayToRGBAColor;
}();
var _worklet_13718304544470_init_data = {
    code: "function toLinearSpace(RGBA,gamma=2.2){const res=[];for(let i=0;i<3;++i){res.push(Math.pow(RGBA[i],gamma));}res.push(RGBA[3]);return res;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["toLinearSpace","RGBA","gamma","res","i","push","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAuoBO,SAAAA,aAASA,CACdC,IAAA,CAAsBC,KACtB,CAAK,GAAG,CACT,CAEC,KAAM,CAAAC,GAAG,CAAG,EAAE,CACd,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAG,CAAC,CAAE,EAAEA,CAAC,CAAE,CAC1BD,GAAG,CAACE,IAAI,CAACC,IAAI,CAACC,GAAG,CAACN,IAAI,CAACG,CAAC,CAAC,CAAEF,KAAK,CAAC,CAAC,CACpC,CACAC,GAAG,CAACE,IAAI,CAACJ,IAAI,CAAC,CAAC,CAAC,CAAC,CACjB,MAAO,CAAAE,GAAG,CACZ"}',
    version: "3.5.4"
};
var toLinearSpace = exports.toLinearSpace = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var toLinearSpace = function toLinearSpace(RGBA) {
        var gamma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2.2;
        var res = [];
        for(var i = 0; i < 3; ++i){
            res.push(Math.pow(RGBA[i], gamma));
        }
        res.push(RGBA[3]);
        return res;
    };
    toLinearSpace.__closure = {};
    toLinearSpace.__initData = _worklet_13718304544470_init_data;
    toLinearSpace.__workletHash = 13718304544470;
    toLinearSpace.__stackDetails = _e;
    return toLinearSpace;
}();
var _worklet_2291875308114_init_data = {
    code: "function toGammaSpace(RGBA,gamma=2.2){const res=[];for(let i=0;i<3;++i){res.push(Math.pow(RGBA[i],1/gamma));}res.push(RGBA[3]);return res;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts",
    sourceMap: '{"version":3,"names":["toGammaSpace","RGBA","gamma","res","i","push","Math","pow"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/Colors.ts"],"mappings":"AAopBO,SAAAA,YAASA,CACdC,IAAA,CAAsBC,KACtB,CAAK,GAAG,CACT,CAEC,KAAM,CAAAC,GAAG,CAAG,EAAE,CACd,IAAK,GAAI,CAAAC,CAAC,CAAG,CAAC,CAAEA,CAAC,CAAG,CAAC,CAAE,EAAEA,CAAC,CAAE,CAC1BD,GAAG,CAACE,IAAI,CAACC,IAAI,CAACC,GAAG,CAACN,IAAI,CAACG,CAAC,CAAC,CAAE,CAAC,CAAGF,KAAK,CAAC,CAAC,CACxC,CACAC,GAAG,CAACE,IAAI,CAACJ,IAAI,CAAC,CAAC,CAAC,CAAC,CACjB,MAAO,CAAAE,GAAG,CACZ"}',
    version: "3.5.4"
};
var toGammaSpace = exports.toGammaSpace = function() {
    var _e = [
        new global.Error(),
        1,
        -27
    ];
    var toGammaSpace = function toGammaSpace(RGBA) {
        var gamma = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2.2;
        var res = [];
        for(var i = 0; i < 3; ++i){
            res.push(Math.pow(RGBA[i], 1 / gamma));
        }
        res.push(RGBA[3]);
        return res;
    };
    toGammaSpace.__closure = {};
    toGammaSpace.__initData = _worklet_2291875308114_init_data;
    toGammaSpace.__workletHash = 2291875308114;
    toGammaSpace.__stackDetails = _e;
    return toGammaSpace;
}();
